import React, {useEffect , useRef } from "react";
import GetCanvasRelativeBounds from "./Utilities/GetCanvasRelativeBounds";
import WebDesigner from "./WebDesigner";




export default function HoveredOutline({webDesigner}:{webDesigner:WebDesigner}){
    
    const thisDom = useRef(null);
    const prevDom = useRef<HTMLElement|null>(null);



    const [hoveredDom,setHoveredDomState] = React.useState<HTMLElement|null>(null);

    const onMutation = ()=>{
      if (!thisDom.current||!hoveredDom)
      return;

   
        let newbounds = GetCanvasRelativeBounds(hoveredDom );
        let target = thisDom.current as HTMLElement
        target.style.height = newbounds.height + "px";
        target.style.width = newbounds.width + "px";
        target.style.top = newbounds.top + "px";
        target.style.left = newbounds.left + "px";

    }

    useEffect(() => {

      let can = document.querySelector(".canvas");
      if(can){
        can.addEventListener("resize",onMutation);
        can.addEventListener("scroll",onMutation);
      }
  
      webDesigner.updateHoverComponent = (dom:HTMLElement|null)=>{
      
        
        setHoveredDomState(dom);
      
    }

        if (thisDom.current && prevDom.current != hoveredDom) {
          //fadeInElement(thisDom.current, 250);
            (thisDom.current as HTMLElement).style.opacity = "1";
        }
        prevDom.current = hoveredDom;

        const resizeObserver = new ResizeObserver((entries) => {
        
            onMutation();

        });
        const mutationObserver = new MutationObserver((entries) => {

          onMutation();
         
        });
    
        if (prevDom.current) {
          resizeObserver.observe(prevDom.current);

        }
        if(can){
          resizeObserver.observe(can);
        }
 
    
        return () => {
         
            resizeObserver.disconnect();
            mutationObserver.disconnect();
            webDesigner.updateHoverComponent =()=>{};//set back to empty function to prevent memory leak
            let can = document.querySelector(".canvas");
            if(can){
              can.removeEventListener("resize",onMutation);
              can.removeEventListener("scroll",onMutation);
            }
        };
    //eslint-disable-next-line
      },[hoveredDom]);



    if(hoveredDom==null)
        return null;


    let bounds =  GetCanvasRelativeBounds(hoveredDom);

    //use a new key per object to reset the fade in
    return(
    <>
    { hoveredDom &&
        <div  key = {hoveredDom.id} ref = {thisDom} className="hover-outline" id="hover-outline" style={{left:bounds.left+"px",top:bounds.top+"px",width:bounds.width+"px",height:bounds.height+"px",opacity:"0"}}></div>
      }
        </>
    );

}